import React from "react";
import "../styles/Home.css";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  const studyPlan = {
    title: "10일 완성 플랜",
    description:
      "단기간 고득점을 목표로 하는 집중 학습 플랜, 10일 토익몬 + 4일 ETS 기출 모의고사\n\n" +
      "토익 학습의 핵심은 '집중도'와 '패턴 인식'입니다. 각 파트별로 하루를 온전히 할애하여 집중 학습하는 것이 " +
      "여러 날에 걸쳐 분산 학습하는 것보다 효과적입니다. 이는 문제 유형의 패턴을 더 명확하게 파악하고, " +
      "각 파트의 특성과 출제 경향을 깊이 있게 이해할 수 있게 해줍니다. 이러한 집중 학습 방식을 통해 " +
      "시험에서 자주 등장하는 표현과 문제 해결 전략을 더 효과적으로 습득할 수 있습니다.",
    schedule: [
      {
        week: "",
        days: [
          {
            day: "DAY 1",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/listening/Part1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part1SelectedCategory",
                      "vocabulary"
                    );
                    navigate("/dashboard/listening/Part1?category=vocabulary");
                  }}
                >
                  1. LC Part 1 단어암기 (예상시간:30분)
                </a>
                <a
                  href="/dashboard/listening/Part1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part1SelectedCategory",
                      "tutorial"
                    );
                    navigate("/dashboard/listening/Part1");
                  }}
                >
                  2. LC 문법 훈련 (예상시간 30분))
                </a>
                <a
                  href="/dashboard/listening/Part1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part1SelectedCategory",
                      "location"
                    );
                    navigate("/dashboard/listening/Part1");
                  }}
                >
                  3. LC Part 1 장소문제 텍스트로만 풀어보기 (200+문제 , 예상시간
                  약 3시간)
                </a>
                <a
                  href="/dashboard/listening/Part1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part1SelectedCategory",
                      "people"
                    );
                    navigate("/dashboard/listening/Part1");
                  }}
                >
                  4. LC Part 1 인물 문제 텍스트로만 풀어보기 (200+, 예상시간
                  약3시간)
                </a>
              </div>
            ),
            reading:
              "1. 영어 어순대로 글을 읽는 훈련을 합니다. 하나씩 영어의 뜻을 보면서 영어어순대로 글을 읽어보려고 해보세요 2. 문장훈련이 끝나면 파트1에만 나오는 단어를 듣고 머릿속에 이미지를 떠올리는 훈련을 해보세요 3.  ",
          },
          {
            day: "DAY 2",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/listening/Part1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part1SelectedCategory",
                      "location"
                    );
                    navigate("/dashboard/listening/Part1");
                  }}
                >
                  1. LC Part 1 장소문제 풀이 (텍스트 보면서 한번, 텍스트 없이
                  한번)
                </a>
                <a
                  href="/dashboard/listening/Part1"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part1SelectedCategory",
                      "people"
                    );
                    navigate("/dashboard/listening/Part1");
                  }}
                >
                  2. LC Part 1사람 사진 풀이 (텍스트 보면서 한번, 텍스트 없이
                  한번)
                </a>
              </div>
            ),
            reading:
              "오늘은 장소 사진 문제를 텍스트로 풀어보세요. 텍스트로 문제를 풀고 난 후 오디오를 들어보면 듣기 능력이 향상됩니다.",
          },
          {
            day: "DAY3",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/listening/Part2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/listening/Part2");
                  }}
                >
                  1. LC Part 2 전체 문제 텍스트로 풀고 음성으로도 들어보기
                  (쉬움, 예상 시간 :6시간)
                </a>
              </div>
            ),
            reading: "RC Part 5 문장구조",
          },
          {
            day: "DAY4",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/listening/Part2"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/listening/Part2");
                  }}
                >
                  1. LC Part 2 텍스트 없이 전체 문제 풀기 (예상시간 5-6시간)
                </a>
              </div>
            ),
            reading: "RC Part 5 오답노트",
          },
          {
            day: "DAY5",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/reading/Part5"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part5SelectedCategory",
                      "blank-training"
                    );
                    navigate("/dashboard/reading/Part5");
                  }}
                >
                  1. RC 빈칸훈련 (예상시간: 1시간)
                </a>
                <a
                  href="/dashboard/reading/Part5"
                  onClick={(e) => {
                    e.preventDefault();
                    window.localStorage.setItem(
                      "part5SelectedCategory",
                      "parts-of-speech"
                    );
                    navigate("/dashboard/reading/Part5");
                  }}
                >
                  2. RC 문장훈련 모두 완료하기 (예상시간:1시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  3. 파트 6&7 광고문 읽기 (보통 재생모드로 읽어도 이해가 될
                  정도로)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  4. 파트 6&7 고객 이메일 읽기 (보통 재생모드로 읽어도 이해가 될
                  정도로)
                </a>
              </div>
            ),
            reading: "RC Part 5 복습",
          },
          {
            day: "DAY6",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  1. 파트 6&7 비지니스 이메일 읽기 (예상시간 : 2시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  2. 파트 6&7 행사 관련 이메일 읽기 (예상시간 : 2시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  3. 파트 6&7 HR관련 이메일 읽기 (예상시간 : 2시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  4. 파트 6&7 대화 지문 읽기(1시간)
                </a>
              </div>
            ),
            reading: "RC Part 5 총정리",
          },
          {
            day: "DAY7",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  1. 파트 6&7 메모 , 알림글 읽기 (예상시간 : 2시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  2. 파트 6&7 기사글 읽기 (예상시간 : 2시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  3. 파트 6&7 보도자료 읽기 (예상시간 : 2시간)
                </a>
                <a
                  href="/dashboard/reading/Part6"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part6");
                  }}
                >
                  2. 파트 6&7 공지사항 글읽기 (예상시간 : 2시간)
                </a>
              </div>
            ),
            reading: "RC Part 6 기초",
          },
          {
            day: "DAY9",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/listening/Part3"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/listening/Part3");
                  }}
                >
                  1. 파트 3 전범위
                </a>
              </div>
            ),
            reading: "RC Part 6 심화",
          },
          {
            day: "DAY10",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/listening/Part4"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/listening/Part4");
                  }}
                >
                  1. 파트 4 전범위
                </a>
              </div>
            ),
            reading: "RC Part 7 기초",
          },
          {
            day: "DAY 11",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                <a
                  href="/dashboard/reading/Part5"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/dashboard/reading/Part5");
                  }}
                >
                  1. 파트 5문제 풀기 (예상시간: 2시간)
                </a>
                어떤 학습자료도 ETS 기출문제를 대체할 수 없습니다. 실제 시험과
                동일한 환경에서 연습하는 것이 가장 효과적입니다.
              </div>
            ),
            reading: "실전 모의고사 연습",
          },
          {
            day: "DAY 12-13",
            listening: (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "8px" }}
              >
                지금까지 토익몬에서 학습한 읽기 방법과 문제 풀이 전략을 활용하여
                기출문제를 풀어보세요. 반드시 실제 시험과 동일하게 시간을 재고,
                답안지 마킹까지 실전처럼 연습하시기 바랍니다. 남은 2일 동안
                7회분의 모의고사를 실제 시험처럼 시간 배분하여 풀어보세요.
              </div>
            ),
            reading: "실전 모의고사 연습",
          },
        ],
      },
    ],
  };

  return (
    <div className="toeic-home-container">
      <h1 className="toeic-home-title">TOEIC 학습 플랜</h1>

      <div className="toeic-study-plans">
        <div className="toeic-plan-card">
          <h2 className="toeic-plan-title">{studyPlan.title}</h2>
          <p className="toeic-plan-description">{studyPlan.description}</p>

          <div className="toeic-plan-schedule">
            <h3>학습 일정</h3>
            {studyPlan.schedule.map((week, weekIdx) => (
              <div key={weekIdx} className="toeic-week-schedule">
                <h4>{week.week}</h4>
                <table className="toeic-schedule-table">
                  <thead>
                    <tr>
                      <th>요일</th>
                      <th>할 일</th>
                    </tr>
                  </thead>
                  <tbody>
                    {week.days.map((day, dayIdx) => (
                      <tr key={dayIdx}>
                        <td className="day-cell">
                          <div className="day-checkbox-container">
                            <input
                              type="checkbox"
                              id={`day-${weekIdx}-${dayIdx}`}
                              className="day-checkbox"
                            />
                            <label htmlFor={`day-${weekIdx}-${dayIdx}`}>
                              {day.day}
                            </label>
                          </div>
                        </td>
                        <td>{day.listening}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
